<div class="footer" [ngClass]="type">
    <ng-content></ng-content>
</div>